import Search from "antd/es/input/Search"
import { memo } from "react"

export type RssKeywordFilterProps = {
    onSearch?: Function
}

export const RssKeywordFilter = memo(function RssKeywordFilter(props: RssKeywordFilterProps) {
    return (
        <Search placeholder="Keywords" enterButton="Search" size="middle" onSearch={(value: string) => props.onSearch ? props.onSearch(value) : undefined} allowClear />
    )
})